import { SUBTRAMITES_CONFIG } from '@/subtramites/constants';

/**
 * Maps subtramite keys to their corresponding route paths
 */
const SUBTRAMITE_ROUTES: Record<string, string> = {
  CATASTRAL: '/catastral',
  RESERVA: '/reserva',
  PLANO_MENSURA: '/planomensura',
  PLANO_DE_RELEVAMIENTO: '/planorelevamiento',
  ATM: '/atm',
  MUNICIPALIDAD: '/municipalidad',
  VIALIDAD: '/vialidad',
  AGUAS: '/aguas',
  EXPENSAS: '/expensas',
  IRRIGACION: '/irrigacion',
  ESTUDIO_RESULTADO: '/estudiotitulo',
  PRESUPUESTOS: '/presupuestos',
  // For "otros" subtramites, we navigate to /otros
  CERTIFICADOS_OTRO: '/otros',
  PLANOS_OTRO: '/otros',
  TRAMITES_OTRO: '/otros',
  ESTUDIO_TITULO_OTRO: '/otros',
  PRESUPUESTOS_OTRO: '/otros',
};

/**
 * Gets the route path for a subtramite based on its label
 * @param subtramiteLabel The label of the subtramite
 * @param tramiteId The ID of the tramite
 * @returns The full route path with tramite ID parameter, or null if no route found
 */
export const getSubtramiteRoutePath = (subtramiteLabel: string, tramiteId: number): string | null => {
  // Find the subtramite key that matches the label
  const subtramiteKey = Object.entries(SUBTRAMITES_CONFIG).find(([key, config]) => {
    const configLabel = typeof config.label === 'function' ? 'Dynamic Label' : config.label;
    return configLabel === subtramiteLabel;
  })?.[0];

  if (!subtramiteKey || !SUBTRAMITE_ROUTES[subtramiteKey]) {
    return null;
  }

  const basePath = SUBTRAMITE_ROUTES[subtramiteKey];
  return basePath;
};

/**
 * Checks if a subtramite can be navigated to (is started)
 * @param status The status of the subtramite
 * @returns Whether the subtramite can be navigated to
 */
export const canNavigateToSubtramite = (status: string): boolean => {
  return status === 'en-proceso' || status === 'finalizado';
};